import {
    Component
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { OutOfTownComponent } from './out-of-town/out-of-town.component';
import { LocalComponent } from './local/local.component';

@Component({
    selector: 'app-home',
    templateUrl: 'home.page.html',
    styleUrls: ['home.page.scss'],
})
export class HomePage {
    constructor(public popoverController: PopoverController) {}

    async showOutOfTownNotes() {
        const popover = await this.popoverController.create({
            component: OutOfTownComponent,
            showBackdrop: true,
            cssClass: 'darker-popover'
        });
        return await popover.present();
    }

    async showLocalNotes() {
        const popover = await this.popoverController.create({
            component: LocalComponent,
            showBackdrop: true,
            cssClass: 'darker-popover'
        });
        return await popover.present();
    }
}
